type HostedVideoSourceType = "vimeo" | "youtube";

function buildHostedContentUrl(
  sourceType: HostedVideoSourceType,
  videoId: string,
): string {
  if (sourceType === "vimeo") {
    return `https://vimeo.com/${videoId}`;
  }

  if (sourceType === "youtube") {
    return `https://www.youtube.com/watch?v=${videoId}`;
  }
}

function buildHostedEmbedUrl(
  sourceType: HostedVideoSourceType,
  videoId: string,
): string {
  if (sourceType === "vimeo") {
    const [numericId, privacyHash] = videoId.split("/");

    return privacyHash
      ? `https://player.vimeo.com/video/${numericId}?h=${privacyHash}`
      : `https://player.vimeo.com/video/${numericId}`;
  }

  if (sourceType === "youtube") {
    return `https://www.youtube.com/embed/${videoId}`;
  }
}

function buildLegacyEmbedUrl(source: string): string {
  const youtubeMatch = source.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]+)/,
  );
  if (youtubeMatch?.[1]) {
    return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
  }

  const vimeoMatch = source.match(/vimeo\.com\/(\d+)(?:\/([A-Za-z0-9]+))?/);
  if (vimeoMatch?.[1]) {
    const [, numericId, privacyHash] = vimeoMatch;
    return privacyHash
      ? `https://player.vimeo.com/video/${numericId}?h=${privacyHash}`
      : `https://player.vimeo.com/video/${numericId}`;
  }

  return source;
}

function getVimeoId(url: string): string | null {
  const match = url.match(/vimeo\.com\/(\d+)/);
  return match ? match[1] : null;
}

export {
  buildHostedContentUrl,
  buildHostedEmbedUrl,
  buildLegacyEmbedUrl,
  getVimeoId,
};
